import React, {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

import useFeatureFlagOnce2 from '../../../hooks/useFeatureFlagOnce2';
import { IdleTimer, IdleTimerProps } from '../IdleTimer';

type UpdateIdleTimerConfig = IdleTimerProps;

type UpdateIdleTimer = (config: UpdateIdleTimerConfig) => void;

type IdleTimerContextType = {
  update: UpdateIdleTimer;
};

type IdleTimerProviderProps = {
  children?: ReactNode;
};

const IdleTimerContext = createContext<IdleTimerContextType>({
  update(_configs: UpdateIdleTimerConfig): void {},
});

export const useIdleTimer = () => useContext(IdleTimerContext);

export const IdleTimerProvider: FC<IdleTimerProviderProps> = ({ children }) => {
  const { value: enableIdleTimeFF } = useFeatureFlagOnce2('login-idle-time');
  const [timeoutMs, setTimeoutMs] = useState<number | undefined>(undefined);

  const update: UpdateIdleTimer = useCallback((config) => {
    setTimeoutMs(config.timeoutMs);
  }, []);

  return (
    <IdleTimerContext.Provider value={{ update }}>
      {children}
      {enableIdleTimeFF && timeoutMs && <IdleTimer timeoutMs={timeoutMs} />}
    </IdleTimerContext.Provider>
  );
};
